import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import styles from './index.scss';

const preventDefault = e => e.preventDefault();
const id = x => x;

const SeButton = ({
    secondary,
    block,
    disabled,
    onClick,
    linkTo,
    children,
    extraClass,
    size,
    external,
}) => {
    const btnClasses = classNames({
        [styles.btn]: true,
        [styles.small]: size === 'small',
        [styles.fullWidth]: block,
        [styles.primary]: !secondary,
        [styles.secondary]: secondary,
        [styles.disabled]: disabled,
        [extraClass]: true,
    });

    if (onClick) {
        return (
            <button className={btnClasses} onClick={onClick}>
                {children}
            </button>
        );
    }

    if (!linkTo) {
        throw new Error(`

            SeButton doesn't have neither linkTo attribute nor onClick handler.
            For correct behavior of a component please provide one.
            <SeButton linkTo='/desired/url'>Link</SeButton>
            Or
            <SeButton onClick={this.clickHandler}>Click</SeButton>

        `);
    }

    const LinkComponent = external ? 'a' : Link;
    const linkProps = {
        [external ? 'href' : 'to']: disabled ? '#' : linkTo,
        onClick: disabled ? preventDefault : id,
    };
    return (
        <LinkComponent role="button" className={btnClasses} {...linkProps}>
            {children}
        </LinkComponent>
    );
};

SeButton.propTypes = {
    secondary: PropTypes.bool,
    disabled: PropTypes.bool,
    block: PropTypes.bool,
    size: PropTypes.string,
    extraClass: PropTypes.string,
    external: PropTypes.bool,
    onClick: PropTypes.func,
    linkTo: PropTypes.string,
    children: PropTypes.any,
};

SeButton.defaultProps = {
    secondary: false,
    disabled: false,
    block: false,
    onClick: null,
    linkTo: null,
    children: null,
    extraClass: '',
    external: false,
    size: '',
};

export default SeButton;
